import { FooterContainer } from "./style" 

export function Footer() {
  return (
    <FooterContainer>
      <h2>EdinaldoFCS</h2>
    </FooterContainer>
  )
}
